import React from 'react';

import {
  Strip,
  StripCount,
  StripItem,
  StripRemove,
  StripThumb,
} from '../styles';

export interface Shot {
  /** Nombre final del fichero: es el id con el que lo conoce el formulario. */
  id: string;
  previewUrl: string;
}

interface Props {
  shots: Shot[];
  label: string;
  photoAlt: string;
  removeLabel: string;
  onRemove: (id: string) => void;
}

/**
 * Lo capturado en esta sesión de cámara, con opción a descartar.
 *
 * Repasar y borrar sin salir del visor es el patrón habitual en las apps de
 * captura: una ráfaga de 15 fotos siempre trae alguna movida o repetida, y
 * obligar a cerrar, buscarla en la rejilla del formulario y borrarla ahí rompe
 * el ritmo justo cuando el operario está documentando.
 *
 * El borrado lo ejecuta el LLAMADOR (`onRemove`), que además de sacarla de la
 * lista borra el fichero de OPFS y anota el cambio en el flujo de edición.
 */
export const ShotStrip = ({
  shots,
  label,
  photoAlt,
  removeLabel,
  onRemove,
}: Props): JSX.Element | null => {
  if (!shots.length) return null;

  return (
    <Strip data-testid="camera-shot-strip" aria-label={label}>
      {/* El contador es una cifra: no se traduce, y así no hace falta meter
          plurales de i18next donde el proyecto no los usa en ningún sitio. */}
      <StripCount>{shots.length}</StripCount>
      {shots.map((shot) => (
        <StripItem key={shot.id}>
          <StripThumb src={shot.previewUrl} alt={photoAlt} />
          <StripRemove
            type="button"
            aria-label={removeLabel}
            title={removeLabel}
            onClick={() => onRemove(shot.id)}
          >
            ×
          </StripRemove>
        </StripItem>
      ))}
    </Strip>
  );
};
